import React from 'react';
import { useState, useEffect } from 'react';
import '../Sliders/productSliders.css';
import img1 from '../../../assets/sliderProducts/1.png'
import img2 from '../../../assets/sliderProducts/2.png'
import img3 from '../../../assets/sliderProducts/3.png'
import img4 from '../../../assets/sliderProducts/4.png'

import './productSliders.css'
    
const images = [img1, img2, img3 , img4];

const ProductSliders = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) => 
            (prevIndex - 1 + images.length) % images.length
        );
    };

    useEffect(() => {
        const interval = setInterval(nextImage, 3500);
        return () => clearInterval(interval);
    }, []);
    
    return (    
            <div className="slider-container2">
                <button className="arrow left-arrow" onClick={prevImage}>
                    &#10094;
                </button>
                <img 
                    className="image-slide" 
                    src={images[currentIndex]} 
                    alt={`Slide ${currentIndex}`} 
                />
                <button className="arrow right-arrow" onClick={nextImage}>
                    &#10095;
                </button>
            </div>
        );
}

export default ProductSliders;
